angular.module('clientDashboardApp').directive('fieldCount', () => {
  return {
    restrict: 'E',
    scope: {
      isSingle: '=',
      count: '=',
      lowerIsBetter: '=', // whether 0 should show x if single
      isNotApplicable: '=' // will display 'N/A' if true. also checks for -1 count
    },
    template: `
      <span ng-switch="!!isNotApplicable || count < 0">
        <i ng-switch-when="true">N/A</i>
        <span ng-switch-when="false" ng-switch="!!isSingle">
          <span ng-switch-when="true">
            <i ng-show="!!lowerIsBetter ? count === 0 : count > 0" class="fas fa-check fa-4" style="color: green">
            </i>
            <i ng-show="!!lowerIsBetter ? count > 0 : count === 0" class="far fa-times fa-4" style="color: red;">
            </i>
          </span>
          <div ng-switch-when="false">            
            <react-component name="PurtyNumber" props="{
              value: {{count}}
            }"/> 
          </div>
        </span>
      </span>
    `
  }
})
